import { IBill } from './IBill.js'

export interface ISummary {
  actionDate: string
  actionDesc: string
  bill: IBill
  currentChamber: string
  currentChamberCode: string
  lastSummaryUpdateDate: string
  text: string
  updateDate: string
  versionCode: string
}
